"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'en': {
        'translation': {
            'No results found': 'No results found',
        }
    },
    'es': {
        'translation': {
            'No results found': 'No se han encontrado resultados',
        }
    },
    'cs': {
        'translation': {
            'No results found': 'Nenalezen žádný záznam',
        }
    },
    'zh': {
        'translation': {
            'No results found': '未找到任何结果'
        }
    },
    'he': {
        'translation': {
            'No results found': 'לא נמצאו תוצאות'
        }
    }
};
